module.exports = __webpack_public_path__ + "media/images/ibu__icon__search-ffd13240e0e523d314ca5a6a2d6e0ba5.svg";